var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiCrossNaked = function SvgAiCrossNaked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#AI-Cross-Naked_svg__a)",
    d: "m12.004 12.706 5.297 5.293.707-.707L12.71 12l5.297-5.294-.707-.707-5.297 5.294-5.297-5.294L6 6.705 11.297 12 6 17.292l.707.707z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "AI-Cross-Naked_svg__a",
    x1: 5.493,
    x2: 20.003,
    y1: 8.356,
    y2: 14.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#7029CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F558C"
  })))));
};
export default SvgAiCrossNaked;